import AnalyticsWebClient, {userType} from "@atlassiansox/analytics-web-client";
import {getEnvironment, shouldUseStargate} from "./utils";
import storage from "../utils/storage";

let globalAnalyticsClient: AnalyticsWebClient;

const atlassianAccountId = (storage.getCookie("__aid_user_id") ?? "").replace(
  /"/g,
  ""
);

export const createAnalyticsClient = (): AnalyticsWebClient => {
  const analyticsEnv = getEnvironment();
  const client = new AnalyticsWebClient(
    {
      env: analyticsEnv,
      product: "marketing",
      version: "1.0.0",
      locale: "en-us"
    },
    {
      useStargate: shouldUseStargate(),
      enableNewEventSender: true,
    });


  if (atlassianAccountId) {
    client.setUserInfo(userType.ATLASSIAN_ACCOUNT, atlassianAccountId);
  } else {
    client.clearUserInfo();
  }

  return client;
}
export const analyticsClient = (): AnalyticsWebClient => {
  if (!globalAnalyticsClient) {
    globalAnalyticsClient = createAnalyticsClient();
  }
  return globalAnalyticsClient;
}